import * as React from "react";
import {cx} from "emotion";
import Dragula from "react-dragula";

import "./folder-tiles.scss";

import {cs}                     from "@Common/react/chain-services";
import {consumeContext}         from "@Common/react/context";
import {keyed}                  from "@Common/react/keyed";
import {Load2}                  from "@Common/react/load2";
import {UseState}               from "@Common/react/use-state";
import {CcApis3}                from "@Common/tools/cc-integration/cc_apis/cc-apis-3";
import {AlertModal}             from "@Common/ui-components/heavy/common/design2/dialogs/alert-modal/alert-modal";
import {ConfirmDialog}          from "@Common/ui-components/heavy/common/design2/dialogs/confirm-dialog/confirm-dialog";
import {faSpinner}              from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon}        from "@fortawesome/react-fontawesome";
import {UserCreatedFolderModal} from "../../user-created-folder-modal/user-created-folder-modal";
import {rTemplateTile}          from "../template-tiles/template-tiles";

export const rFolderTiles = ({
    activeTab, deleted, forceUpdate, index, folder, folders, showInactive, templateUploadModal, updatingFolderSequence, viewMode, dragulaTemplatesDecorator
}) => cs(
    keyed(`FolderTile${folder?.idPrimary}-${forceUpdate.value}`),
    consumeContext("apis"),
    consumeContext("catSubStyle"),
    consumeContext("company"),
    consumeContext("systemConstants"),
    ["alertModal", ({}, next) => AlertModal({next})],
    ["confirmModal", ({}, next) => ConfirmDialog({next})],
    ["disable", (_, next) => UseState({next})],
    ["folderModal",({}, next) => UserCreatedFolderModal({
        activeTab,
        folderId: folder.idPrimary,
        index,
        folders,
        next,
    })],
    ["show", (_, next) => UseState({ initValue: true, next })],
    ["templates", ({apis}, next) => Load2({
        _key: JSON.stringify([forceUpdate.value, showInactive]),
        fetch: () => apis.next.userCreated.getTemplates( folder.idPrimary, 0, deleted ),
        next,
    })],
    ({alertModal, apis, catSubStyle, company, disable, confirmModal, folderModal, show, systemConstants, templates}) => {
        let activeTemplates = templates.value ? Object.values(templates.value).filter((template) => template?.active).length : 0;
        let inactiveTemplates = templates.value ? Object.values(templates.value).filter((template) => !template?.active).length : 0;
        return <div className="folder-tiles-ld3" id={`${folder.idPrimary}FolderId`}>
            <div id="folder-div" className="accord folder-header">
                <div>
                    <b>{folder.name}</b>
                    {activeTemplates ? <span xd-qa-type="badge" xd-qa-name="Active Template Count" className="badge active">
                        {activeTemplates + " Active"}
                    </span> : ''}
                    {inactiveTemplates ? <span xd-qa-type="badge" xd-qa-name="Inactive Template Count" className="badge inactive">
                        {inactiveTemplates + " Inactive"}
                    </span> : ''}
                    {!templates.loading && !Object.keys(templates.value).length ? <span xd-qa-type="badge" xd-qa-name="Empty" className="badge empty">
                        Empty
                    </span> : <></>}
                    {folder.idPrimary && activeTab !== 'archive' ? <>
                        <a className={cx("icon edit", disable.value ? "disable" : "")} xd-qa-type="link" xd-qa-name="Edit Folder Information"
                            onClick={() => {
                                if(!disable.value) {
                                    folderModal.show();
                                }
                            }}
                        >
                            Edit
                        </a>
                        {" | "}
                        {templates.loading || templates.value.length ? <a
                            className={cx("icon archive", disable.value ? "disable" : "")}
                            xd-qa-type="link"
                            xd-qa-name="Archive Folder"
                            onClick={async () => {
                                if (await confirmModal.show({
                                    message: "Archive Folder",
                                    buttons: {
                                        confirmLabel: "Archive",
                                    }
                                })) {
                                    if(disable.value) {
                                        return;
                                    }
                                    disable.onChange(true);
                                    let result = await apis.next.userCreated.updateFolder({updateFields: {'idPrimary': folder.idPrimary, 'isArchived': 1}});
                                    if( result?.errors || result?.errorMessage ) {
                                        await alertModal.show({message: "Error archiving folder."});
                                        return;
                                    }
                                    folders.onChange(folders.value.filter((e) => e.idPrimary != folder.idPrimary));
                                    await catSubStyle?.reload();
                                    disable.onChange(false);
                                }
                            }}
                        >Archive</a> : <a
                            className={cx("icon delete", disable.value ? "disable" : "")}
                            xd-qa-type="link"
                            xd-qa-name="Delete Folder"
                            onClick={async () => {
                                if (await confirmModal.show({
                                    message: "Delete Folder",
                                    buttons: {
                                        confirmLabel: "Delete",
                                    }
                                })) {
                                    if(disable.value) {
                                        return;
                                    }
                                    disable.onChange(true);

                                    const result = await apis.next.userCreated.deleteFolder( folder.idPrimary );
                                    if (result?.errors || result?.errorMessage) {
                                        alert("Error deleting folder.");
                                        return;
                                    }

                                    folders.onChange(folders.value.filter((e) => e.idPrimary != folder.idPrimary));
                                    disable.onChange(false);
                                }
                            }}
                        >Delete</a>}
                    </> : folder.isArchived && activeTab == 'archive' ? <>
                        <a className={cx("icon restore", disable.value ? "disable" : "")} xd-qa-type="link" xd-qa-name="restore Folder" onClick={async () => {
                            if (await confirmModal.show({
                                message: "Restore Folder",
                                buttons: {
                                    confirmLabel: "Restore",
                                }
                            })) {
                                if(disable.value) {
                                    return;
                                }
                                disable.onChange(true);
                                let result = await apis.next.userCreated.updateFolder({updateFields: {'idPrimary': folder.idPrimary, 'isArchived': 0}});
                                if( result?.errors || result?.errorMessage ) {
                                    await alertModal.show({message: "Error restoring folder."});
                                    return;
                                }
                                folders.onChange(folders.value.filter((e) => e.idPrimary != folder.idPrimary));
                                await catSubStyle?.reload();
                                disable.onChange(false);
                            }
                        }}>Restore</a>
                        {" | "}
                        <a className={cx("icon delete", disable.value ? "disable" : "")} xd-qa-type="link" xd-qa-name="Delete Folder" onClick={async () => {
                            if (await confirmModal.show({
                                message: "Delete Folder",
                                actionContent: "Templates cannot be restored. Are you sure you want to proceed?",
                                buttons: {
                                    confirmLabel: "Delete",
                                }
                            })) {
                                if(disable.value) {
                                    return;
                                }
                                disable.onChange(true);
                                await Promise.all(Object.values(templates.value).map(async (template: any) => {
                                    if( template.idState ) {
                                        const ccApis = CcApis3({
                                            host: systemConstants.value.DS_SERVER_URL,
                                            headers: {
                                                "userguid": `company-${company.idCompany}`
                                            }
                                        })
                                        await ccApis.deleteState(template.idState)
                                    }
                                    const result = await apis.next.userCreated.deleteTemplate({'idPrimary': template.idPrimary});
                                    if (result?.errors || result?.errorMessage) {
                                        await alertModal.show({message: `Error deleting template ${template.idPrimary}.`});
                                        return;
                                    }
                                }));
                                const result = await apis.next.userCreated.deleteFolder( folder.idPrimary );
                                if (result?.errors || result?.errorMessage) {
                                    alert("Error deleting folder.");
                                    return;
                                }

                                if( templates.value.length ) {
                                    forceUpdate.onChange(!forceUpdate.value);
                                }

                                folders.onChange(folders.value.filter((e) => e.idPrimary != folder.idPrimary));
                                disable.onChange(false);
                            }
                        }}>Delete</a>
                        </> : <>
                    </>}
                </div>
                <div>
                    {(activeTemplates || (showInactive && inactiveTemplates))  ? <>
                        <a className={show.value ? "collapse fa fa-chevron-down": "collapse fa fa-chevron-up"} xd-qa-type="icon" onClick={() => show.onChange(!show.value)}/>
                    </> : (activeTab != 'archive' && !templates.loading && !Object.keys(templates.value).length) ? <button
                            aria-label="Create New Template" className="createNewTemplate"
                            xd-qa-type="button" xd-qa-name="Create New Template" onClick={() => {
                                window.location.hash = "#new-template";
                                templateUploadModal.show()
                            }}
                        >New Template</button> : <></>}
                </div>
            </div>
            <div className={cx("spinner-footer", !templates.loading && "hide")} xd-qa-type="label" xd-qa-name="Loading">
                <FontAwesomeIcon icon={faSpinner} className="fa-pulse"/>
            </div>
            {!templates.loading ? ( show.value && ( activeTemplates || (showInactive && inactiveTemplates) ) ?
                <div className={cx("folder-content", (updatingFolderSequence) && "hide")} ref={dragulaTemplatesDecorator}>
                    {Object.values(templates.value).filter((template) => showInactive || template?.active).map((template: any, index) => (
                        rTemplateTile({activeTab, forceUpdate, index, template, templates, viewMode})
                    ))}
                </div> : <div className={cx("folder-content", (updatingFolderSequence || activeTab == 'archive') && "hide")} ref={dragulaTemplatesDecorator}></div>
            ) : <></>}
        </div>;
    }
);